/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';
import type { SerializedStyles } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import type { ImageType } from 'bundles/cds-labs/components/Modules/components/Image';
import Image from 'bundles/cds-labs/components/Modules/components/Image';
import { getColorFromColorName, getFgColorFromBgColorName } from 'bundles/cds-labs/components/Modules/utils/colors';

export type EyebrowProps = {
  text?: string | null;
  background?: string | null;
  image?: ImageType | null;
  eyebrowImageHeight?: number | null;
};

const styles = {
  eyebrowBackground: css`
    padding: 2px var(--cds-spacing-150);

    /* ensure round corners regardless of height */
    border-radius: 1000px;
  `,
};

function Eyebrow({ text, background, image, eyebrowImageHeight }: EyebrowProps) {
  const pillStyles: Array<SerializedStyles> = [];
  if (background) {
    const bgColor = getColorFromColorName(background);
    if (bgColor) {
      const color = getFgColorFromBgColorName(background);
      pillStyles.push(css`
        background-color: ${bgColor};
        color: ${color};
      `);
      pillStyles.push(styles.eyebrowBackground);
    }
  }

  return (
    <div>
      {image && <Image {...image} height={eyebrowImageHeight ?? Math.min(image.height ?? 32, 32)} />}
      {!image && text && (
        <div>
          <span css={pillStyles}>
            <Typography2 variant="subtitleSmall" component="span" color="inherit">
              {text}
            </Typography2>
          </span>
        </div>
      )}
    </div>
  );
}

export default Eyebrow;
